export default "__VITE_ASSET__Ca$T6BH8__"